"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabsHeaderList = exports.StyledTabsHeaderWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const computeLineWidth = ({
  alternateStyling,
  isInSidebar,
  position
}) => {
  if (isInSidebar && position === "left") {
    return "0px";
  }

  return alternateStyling ? "-1px" : "-2px";
};

const StyledTabsHeaderWrapper = _styledComponents.default.div`
  ${({
  position,
  isInSidebar
}) => position === "left" && (0, _styledComponents.css)`
      overflow-y: auto;
      box-sizing: border-box;
      padding: 2px;

      ${!isInSidebar && (0, _styledComponents.css)`
        min-width: 20%;
      `}

      ${isInSidebar && (0, _styledComponents.css)`
        min-width: 100%;
        margin: auto;
        padding: 0px;
      `}
    `}
`;
exports.StyledTabsHeaderWrapper = StyledTabsHeaderWrapper;
const StyledTabsHeaderList = _styledComponents.default.ul`
  display: flex;
  box-shadow: inset 0px ${computeLineWidth} 0px 0px
    ${({
  theme
}) => theme.tab.background};
  ${({
  extendedLine
}) => !extendedLine && (0, _styledComponents.css)`
      width: fit-content;
    `}
  cursor: pointer;
  list-style: none;
  margin: 0;
  padding: 0;

  ${({
  align
}) => align === "right" && (0, _styledComponents.css)`
      justify-content: flex-end;
      text-align: right;
    `}

  ${({
  position,
  noRightBorder,
  theme
}) => position === "left" && (0, _styledComponents.css)`
      flex-direction: column;
      box-shadow: inset ${computeLineWidth} 0px 0px 0px ${theme.tab.background};

      ${noRightBorder && (0, _styledComponents.css)`
        box-shadow: none;
      `}

      ${({
  align
}) => align === "right" && (0, _styledComponents.css)`
          justify-content: flex-start;
        `}
    `}
`;
exports.StyledTabsHeaderList = StyledTabsHeaderList;
StyledTabsHeaderWrapper.defaultProps = {
  position: "top"
};
StyledTabsHeaderWrapper.propTypes = {
  position: _propTypes.default.oneOf(["top", "left"]),
  isInSidebar: _propTypes.default.bool
};
StyledTabsHeaderList.defaultProps = {
  align: "left",
  position: "top",
  extendedLine: true,
  theme: _base.default
};
StyledTabsHeaderList.propTypes = {
  align: _propTypes.default.oneOf(["left", "right"]),
  position: _propTypes.default.oneOf(["top", "left"]),
  isInSidebar: _propTypes.default.bool
};